import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { RoutingService } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { KnBrStaffRow } from '../../../feature-libs/kn-br-organization/administration/components/shared/kn-br-staff-customer-tabs/kn-br-staff-customer.models';
import { AtgUserManagementService, UserManagementMode } from './atg-user-management.service';

@Component({
  selector: 'atg-user-management',
  templateUrl: './atg-user-management.component.html',
  styleUrls: ['./atg-user-management.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AtgUserManagementComponent implements OnInit, OnDestroy {
  mode$: Observable<UserManagementMode>;
  selectedUser$: Observable<KnBrStaffRow | null>;
  private subscriptions = new Subscription();

  constructor(
    private userManagementService: AtgUserManagementService,
    private routingService: RoutingService,
    private cdr: ChangeDetectorRef,
  ) {
    this.mode$ = this.userManagementService.mode$;
    this.selectedUser$ = this.userManagementService.selectedUser$;
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.routingService.getRouterState().pipe(
        filter((routerState) => !routerState.nextState),
      ).subscribe((routerState: any) => {
        const params = routerState?.state?.queryParams || {};
        const mode = params['mode'];
        const customerId = params['customerId'];

        if (mode === 'edit' && customerId) {
          this.userManagementService.fetchAndSetEditUser(customerId);
        } else {
          this.userManagementService.setAddUser();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.userManagementService.clear();
  }
}
